/**
 * Created by slava on 9/8/17
 */

const ColorBooster = function (id) {
    FieldBooster.call(this, id);
};

ColorBooster.prototype = Object.create(FieldBooster.prototype);
ColorBooster.prototype.constructor = ColorBooster;

ColorBooster.prototype.listAffected = function (targetCell) {
    const res = [], resTiles = [];

    this.targetCell = targetCell;
    const needColor = targetCell.getColor();

    for (let i = 0; i < Field.SIZE; i++) {
        for (let j = 0; j < Field.SIZE; j++) {
            if (Game.currentGame.field.cells[i][j] && Game.currentGame.field.cells[i][j].hurtable) {
                if (Game.currentGame.field.cells[i][j].getColor() === needColor && (needColor !== undefined || Game.currentGame.field.cells[i][j] === targetCell)) {
                    res.push(Game.currentGame.field.cells[i][j]);
                    if (Game.currentGame.field.floor[i][j]) {
                        resTiles.push(Game.currentGame.field.floor[i][j]);
                    }
                }
            }
        }
    }

    return { cells: res, tiles: resTiles };
};

ColorBooster.prototype.getViewClass = function () {
    return ColorBoosterView;
};

ColorBooster.prototype.hurtCells = function (cells) {
    FieldBooster.prototype.hurtCells.call(this, cells);

    Game.currentGame.counter.setTimeout(() => {
        cleverapps.effects.fire("match3.booster.rocket.hit");
        const toAnimate = [];
        Array.prototype.push.apply(toAnimate, cells);
        cleverapps.shuffleInPlace(toAnimate).forEach((cell) => {
            cell.animate(BaseCell.ANIMATION_MULTI_COLOR_SELECT);
        });

        cells.forEach((cell, id) => {
            this.hurtCell(cell, id, cells.length);
        });

        if (Game.currentGame) {
            Game.currentGame.shakeField();
        }
    }, ColorBooster.HURT_DELAY);
};

ColorBooster.HURT_DELAY = 900;

if (cleverapps.config.name === "adventure") {
    ColorBooster.HURT_DELAY = 1400;
}